<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5" id="grad1">
          <!-- breadcrumb and title row starts -->
          <div class="row">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/Admin/adminDashboard'
                  },

                  {
                    title: 'Event Wizard',
                   
                  },
                  {
                    title: ` ${updateTraining.title}`,
                    active: true,
                    class: 'font-bold'
                  }
                ]"
              ></vs-breadcrumb>
            </div>
            <div class="col-sm-12">
              <div class="heading mt-3">
                <h3 class="text-secondary">Event Wizard</h3>
              </div>
            </div>
          </div>
          <!-- breadcrumb and title row Ends -->
          <div class="row justify-content-center mt-0">
            <div class="col-11 text-center p-0 mt-3 mb-2">
              <div class="card px-0 pb-0 mt-3 mb-3">
                <div class="row">
                  <div class="col-md-12 mx-0">
                    <form id="msform">
                      <!-- progressbar -->
                      <ul id="progressbar">
                        <li
                          title="Warning! You are not authorized to access."
                          id="NewTraining"
                        >
                          <strong>Event Assignment</strong>
                        </li>
                        <li
                          title="Warning! You are not authorized to access."
                          id="PoAssignment"
                        >
                          <strong>P.O Assignment</strong>
                        </li>
                        <li
                          @click="trainingInformation()"
                          class="completed"
                          id="TrainingInformation"
                        >
                          <strong>Event Information</strong>
                        </li>
                        <li
                          @click="trainerRegistration()"
                          class="completed"
                          id="TrainerRegistration"
                        >
                          <strong>Facilitators' Registration</strong>
                        </li>
                        <li
                          @click="trainingAgenda()"
                          class="completed"
                          id="TrainingAgenda"
                        >
                          <strong>Event Agenda</strong>
                        </li>
                        <li
                          @click="trainingMaterial()"
                          class="completed"
                          id="Trainingmaterial"
                        >
                          <strong>Upload Material</strong>
                        </li>
                        <li
                          @click="trainingAssessment()"
                          class="completed"
                          id="TrainingAssessments"
                        >
                          <strong>Assessments</strong>
                        </li>

                        <li
                          @click="traineeReg()"
                          class="completed"
                          id="TraineeRegistration"
                        >
                          <strong>Participants' Registration</strong>
                        </li>
                        <li class="active" id="AssessmentReview">
                          <strong>Assessment Review</strong>
                        </li>
                        <li @click="trainingCompletion()" id="Completion">
                          <strong>Completion</strong>
                        </li>
                      </ul>
                      <!-- fieldsets -->
                      <fieldset style="text-align: left;padding: 30px;">
                        <!-- Next Step Button Starts  -->
                        <div class="row">
                          <div class="col-md-12 mb-2">
                            <h5>Event Assessment Execution</h5>
                            <div class="text-right" style="margin-top:-40px">
                              <router-link
                                :to="{ path: '/dashboard/programOfficer/trainee-registration', query: { trainingId: this.trainingCode}}"
                                class="btn btn-primary btn-sm m-1"
                                >Previous Step</router-link
                              >

                              <div
                                @click="completeTraining(trainingCode)"
                                class="btn btn-primary btn-sm"
                              >
                                Save & Complete
                              </div>
                              <button
                                type="button"
                                v-on:click="allTrainer()"
                                class="btn btn-primary btn-sm m-1"
                              >
                                <vs-icon
                                  icon="refresh"
                                  title="Refresh"
                                ></vs-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                        <!-- Next Step Button Ends  -->

                        <!-- row 1 starts  -->
                        <div class="row">
                          <div
                             v-if="this.updateTraining.typetraining_id == 1"
                            class="d-flex flex-row bd-highlight mb-3"
                            style="padding-left:12px"
                          >
                            
                              <div class="bd-highlight">
                              <div class="form-check">
                                <vs-checkbox
                                  v-model="preAssesment"
                                  @change="handlePreChange($event)"
                                  :disabled="!isDateValid"
                                >
                                  <b>PreAssesment</b>
                                  <br />
                                  <span class="text-success">Enable</span>
                                </vs-checkbox>
                              </div>
                            </div>
                            <div class="bd-highlight">
                              <div class="form-check">
                                <vs-checkbox
                                  v-model="postAssesment"
                                  @change="handlePostChange($event)"
                                  :disabled="!preAssesment || !isDateValid"
                                >
                                  <b>PostAssesment</b>
                                  <br />
                                  <span class="text-success">Enable</span>
                                </vs-checkbox>
                              </div>
                            </div>
                            <div class="bd-highlight">
                              <div class="form-check">
                                <vs-checkbox
                                  v-model="traineefeedback"
                                  @change="handleFeedbackChange($event)"
                                  :disabled="!postAssesment || !isDateValid"
                                >
                                  <b>Feedback</b>
                                  <br />
                                  <span class="text-success">Enable</span>
                                </vs-checkbox>
                              </div>
                            </div>
                            <div class="bd-highlight">
                              <div class="form-check">
                                <vs-checkbox
                                  v-model="trainingStatus"
                                  @change="handleTrainingStatusChange($event)"
                                  :disabled="!traineefeedback || !isDateValid"
                                >
                                  <b>Event</b>
                                  <br />
                                  <span class="text-success">Closure</span>
                                </vs-checkbox>
                              </div>
                            </div>
                            <div class="bd-highlight">
                              <div class="form-check">
                                <vs-checkbox
                                  v-model="certificateStatus"
                                  @change="handleCertificateStatusChange($event)"
                                  
                                >
                                  <b>Certificate</b>
                                  <br />
                                  <span class="text-success">Enable</span>
                                </vs-checkbox>
                              </div>
                            </div>
                          </div>

                          <!-- --- -->
                          <div
                             v-else
                            class="d-flex flex-row bd-highlight mb-3"
                            style="padding-left:12px"
                          >
                          
                            <div class="bd-highlight">
                              <div class="form-check">
                                <vs-checkbox
                                  v-model="trainingStatus"
                                  @change="handleTrainingStatusChange($event)"
                                  
                                >
                                  <b>Event</b>
                                  <br />
                                  <span class="text-success">Closure</span>
                                </vs-checkbox>
                              </div>
                            </div>
                            <div class="bd-highlight">
                              <div class="form-check">
                                <vs-checkbox
                                  v-model="certificateStatus"
                                  @change="handleCertificateStatusChange($event)"
                                  
                                >
                                  <b>Certificate</b>
                                  <br />
                                  <span class="text-success">Enable</span>
                                </vs-checkbox>
                              </div>
                            </div>
                          </div>
                          <div class="table-responsive">
                            <div class="col-sm-12">
                              <!-- new form popup starts -->
                              <div class="form-group">
                                <div class="row">
                                  <div class="col-sm-12">
                                    <table class="table table-hover">
                                      <tr>
                                        <th>Sr#</th>
                                        <th>Name</th>
                                        <th>CNIC Number</th>
                                        <th>Contact Number</th>
                                        <th>Username</th>
                                        <th>Pre</th>
                                        <th>Post</th>
                                      </tr>

                                      <tr
                                        v-for="(item, index) in itemsTrainee"
                                        v-bind:key="item.id"
                                      >
                                        <td>{{index+1}}</td>
                                        <td
                                          v-if="item.name != null"
                                          class="text-capitalize"
                                        >
                                          {{item.name}}
                                        </td>
                                        <td v-else>NULL</td>
                                        <td v-if="item.cnic != null">
                                          {{item.cnic}}
                                        </td>
                                        <td v-else>NULL</td>
                                        <td v-if="item.contactNo != null">
                                          {{item.contactNo}}
                                        </td>
                                        <td v-else>NULL</td>
                                        <td v-if="item.username != null">
                                          {{item.username}}
                                        </td>
                                        <td v-else>NULL</td>
                                        <td
                                          v-if="item.preassesmentcheck =='found'"
                                        >
                                          <span>
                                            <vs-icon
                                              class="mr-1"
                                              icon="check"
                                              style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                            ></vs-icon>
                                          </span>
                                        </td>
                                        <td v-else>
                                          <vs-icon
                                            class="mr-1"
                                            icon="close"
                                            style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                          ></vs-icon>
                                        </td>
                                        <td
                                          v-if="item.postassesmentcheck =='found'"
                                        >
                                          <span>
                                            <vs-icon
                                              class="mr-1"
                                              icon="check"
                                              style="color:#007bff;font-size:20px;font-weight:600;cursor: pointer;"
                                            ></vs-icon>
                                          </span>
                                        </td>
                                        <td v-else>
                                          <vs-icon
                                            class="mr-1"
                                            icon="close"
                                            style="color:#ff0000c7;font-size:20px;font-weight:600;cursor: pointer;"
                                          ></vs-icon>
                                        </td>
                                      </tr>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              <!-- new form popup ends -->
                            </div>
                          </div>
                        </div>
                      </fieldset>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import axios from "axios";


export default {
  data: () => ({
    isSidebar: false,
    preAssesment: "",
    postAssesment: "",
    traineefeedback: "",
    trainingStatus: "",
    certificateStatus:"",
    whichSelect: 0,
    role: "",
    designation: "",
    valuesArray: [],
    options1: [
      { text: "Passport", value: 0 },
      { text: "CNIC", value: 1 }
    ],
    radios1: "",
    gender: "",
    success: "",
    passport: "",
    institute: "",
    passing_year: "",
    certificate: "",
    district: "",
    email: "",
    error: "",
    isEditForm: "",
    cnic: "",
    inValid: [],
    updateTraining: [],
    isForm: true,
    isFormData: false,
    selected: "",
    tabIndex: 0,
    contact_person: "",
    contact_number: "",
    contact_email: "",
    address: "",
    primaryUserId: "",
    userId: "",
    components: {
      // VueTagsInput
    },
    country: 1,
    province: 1,
    tag: "",
    tags: [],
    rolesArr: [],
    registeredTrainerArr: [],
    trainingId: "",
    trainingCode: "",
    roleuser: "",
    departmentArr: [],
    department: "",
    designationArr: [],
    sessionByArray: [],
    textarea: "",
    counterDanger: false,
    mydate: "",
    startDate: "",
    endDate: "",
    colorx: "#1db952",
    indexActive: 0,
    trainingCheck: false,
    repeatedCheck: false,
    code: "",
    name: "",
    mobilenumber: "",
    thematicareaSelected: "",
    thematicareasettings: {
      valueField: "code",
      labelField: "name",
      maxItems: 5,
      plugins: ["remove_button"],
      delimiter: "|"
    },
    traineridentityArr: [
      { text: "CNIC Number", value: 1 },
      {
        text: "Passport Number",
        value: 2
      }
    ],

    languageskillsArr: [
      { text: "English", value: 1 },
      { text: "French", value: 2 },
      { text: "German", value: 3 },
      { text: "Chinese", value: 4 }
    ],
    selectlevelArr: [
      { text: "Good", value: 1 },
      { text: "Very Good", value: 2 },
      { text: "Excellent", value: 3 },
      { text: "Weak", value: 4 }
    ],
    countryArr: [],
    trainingArr: [],
    provinceArr: [],
    districtArr: [],
    degreenameArr: [],
    degreesubjectArr: [
      { text: "Management Science", value: 1 },
      { text: "Computer Science", value: 2 },
      { text: "Software Engineering", value: 3 }
    ],
    jobnatureArr: [
      { text: "Permanent", value: 1 },
      { text: "Temporary", value: 2 }
    ],
    itemsTrainee: [],
    items: [
      {
        contact_person: "Dr Saif Ullah",
        department: "Police Dedpartment KP",
        city: "Mardan"
      },

      {
        contact_person: "Dr Ata Ullah",
        department: "Police Dedpartment ISLAMABAD",
        city: "Peshawar"
      }
    ],
    fields: [
      { key: "city", label: "City" },
      { key: "department", label: "Department" },
      { key: "contact_person", label: "Contact Person" },
      { key: "actions", label: "" }
    ],
    training_status: "",
     trainingEndDate: "",
    isDateValid: true,
  }),
  watch: {
    country(val) {
      this.openLoading();
      axios
        .get(localStorage.getItem("BASE_PATH") + "/provinces/get/" + val
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.provinceArr = response.data;
        });
    },
    province(val) {
      this.openLoading();
      axios
        .get(localStorage.getItem("BASE_PATH") + "/districts/get/" + val
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.districtArr = response.data;
        });
    }
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')

    //Select all countries

    this.trainingCode = this.$route.query.trainingId;
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/programOfficer/trainingsingle/get/" +
          this.trainingCode

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.updateTraining = response.data.training;
        this.trainingId = response.data.training.id;
        this.training_status = response.data.training.trainingstatus;
        this.trainingEndDate = response.data.training.enddate;
        this.dateCheck();
        this.allTrainer();
        this.getAllTraining();
        this.preAssesment = response.data?.training?.preassesment_status ?? '';
        this.postAssesment = response.data?.training?.postassesment_status ?? '';
        this.traineefeedback = response.data?.training?.feedbackstatus ?? '';
        this.trainingStatus = response.data?.training?.close_status ?? '';
        this.certificateStatus = response.data?.training?.download_certificate_status ?? '';

      });

    //get result of trainers
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/trainers/all/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.valuesArray = response.data;
      });

    //select all provinces
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/provinces/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.provinceArr = response.data;
      });
    //select all district
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/districts/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.districtArr = response.data;
      });
    //select all degree names
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/degreenames/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.degreenameArr = response.data;
      });
    // department
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/departments/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.departmentArr = response.data;
      });
    //designation
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/designations/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.designationArr = response.data;
      });

    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/traineeroles/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.role = response.data[0].id;
      });
    //select all Training Name
    this.openLoading();
    axios
      .get(localStorage.getItem("BASE_PATH") + "/trainers/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainingArr = response.data;
      });
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
  },

  methods: {
    // onclick show wizard steps
    trainingInformation() {
      this.$router.push({
        path: "/dashboard/programOfficer/training-information",
        query: { trainingId: this.trainingCode }
      });
    },
    trainerRegistration() {
      this.$router.push({
        path: "/dashboard/programOfficer/trainer-registration",
        query: { trainingId: this.trainingCode }
      });
    },
    trainingAgenda() {
      this.$router.push({
        path: "/dashboard/programOfficer/training-agenda",
        query: { trainingId: this.trainingCode }
      });
    },
    trainingMaterial() {
      this.$router.push({
        path: "/dashboard/programOfficer/wizardUploadMaterial",
        query: { trainingId: this.trainingCode }
      });
    },
    trainingAssessment() {
      this.$router.push({
        path: "/dashboard/programOfficer/training-assesment",
        query: { trainingId: this.trainingCode }
      });
    },
    traineeReg() {
      this.$router.push({
        path: "/dashboard/programOfficer/trainee-registration",
        query: { trainingId: this.trainingCode }
      });
    },
    trainingCompletion() {
      if (this.training_status == "In Queue") {
        this.$toasted.global.errorMsg(
          "Please complete all steps by clicking on Save & Next button"
        );
      } else {
        this.$router.push({
          path: "/dashboard/programOfficer/wizard-completion",
          query: { trainingId: this.trainingCode }
        });
      }
    },

    completeTraining(code) {
      this.trainingFilterArr = [];
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/training/status/complete/" +
            code

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.$router.push({
            name: "wizardCompletion",
            query: { trainingId: code }
          });
        });
    },
    unassignedTraining(id) {
      this.openLoading();
      axios
        .post(
          localStorage.getItem("BASE_PATH") +
            "/training/officer/un-assigned/trainee",
          {
            trainingId: this.trainingId,
            trainee: id
          }

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.success) {
            this.$toasted.global.successMsg("Training Un Assigned successfully!");
            this.getAllTraining();
          }
        });
    },
    assignedTraining(id) {
      this.openLoading();
      axios
        .post(
          localStorage.getItem("BASE_PATH") +
            "/training/officer/assigned/trainee",
          {
            trainingId: this.trainingId,
            trainee: id
          }

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response.data.success) {
            this.$toasted.global.successMsg("Assigned Training successfully!");
            this.getAllTraining();
          }
        });
    },
    closeEditForm() {
      this.isForm = true;
      this.isEditForm = false;
      this.resetForm();
    },
    editRecord(id) {
      this.isForm = false;
      this.isEditForm = true;
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") + "/trainee/user/" + id + "/edit"

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (response) {
            this.name = response.data.userstrainee.name;
            this.code = response.data.userstrainee.code;
            this.mobilenumber = response.data.userstrainee.contactNo;
            this.email = response.data.userstrainee.username;
            this.cnic = response.data.cnic;
            this.passport = response.data.passportNo;
            this.gender = response.data.gender;
            this.userId = id;
            this.primaryUserId = response.data.user_trainee_id;
            // this will scrollTop to edit form
            window.scrollTo(0, 0);
          }
        });
    },
    deleteRecord(id) {
      this.$bvModal
        .msgBoxConfirm("Please confirm that you want to delete?", {
          title: "Please Confirm",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "Delete",
          cancelTitle: "Cancel",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value == true) {
            this.openLoading();
            axios
              .post(localStorage.getItem("BASE_PATH") + "/trainee/delete", {
                id: id
              })
              .then(response => {
                this.closeLoading();
                if (response.data.success) {
                  this.$toasted.global.successMsg("Record has been deleted successfully!");
                  this.allTrainer();
                } else if (response.data.error) {
                  throw response.data.error;
                }
              })
              .catch(error => {
                this.$toasted.global.errorMsg(error);
              });
          }
        });
    },
    getAllTraining() {
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/trainee/get/all/fortraining/" +
            this.trainingId

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.registeredTrainerArr = response.data;
        });
    },
    allTrainer: function allTrainer() {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") + "/trainee/show/" + this.trainingId

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();

          this.itemsTrainee = response.data;
        });
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    handlePreChange: function(e) {
      e.stopPropagation();
      e.preventDefault();
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/enable-preassesment/" +
            this.trainingId +
            "/" +
            this.preAssesment

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
        });
    },
    handleTrainingStatusChange: function(e) {
      e.stopPropagation();
      e.preventDefault();
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/close-training/" +
            this.trainingId +
            "/" +
            this.trainingStatus

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
        });
    },
    handlePostChange: function(e) {
      e.stopPropagation();
      e.preventDefault();
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/enable-postassesment/" +
            this.trainingId +
            "/" +
            this.postAssesment

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
        });
    },
    handleFeedbackChange: function(e) {
      e.stopPropagation();
      e.preventDefault();
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/enable-feedback/" +
            this.trainingId +
            "/" +
            this.traineefeedback

        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);

          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
        });
    },
    handleCertificateStatusChange(e){
      axios.get(localStorage.getItem("BASE_PATH") + "/admin/upload-certificates/" + this.trainingId)
      .then(response => {
          if(response.data.length <= 0){
            this.toastError('Please 1st upload Certificate');
            this.certificateStatus = false;
            return;
          }else{
            e.stopPropagation();
      e.preventDefault();
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/download-certificate-status/" +
            this.trainingId +
            "/" +
            this.certificateStatus

        )
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.closeLoading();
        });
          }
        });
      
      
    },
    toastSuccess(msg) {
      this.$bvToast.toast(msg, {
        title: "Success",
        autoHideDelay: 10000,
        variant: "success",
        solid: true
      });
    },
    toastError(msg) {
      this.$bvToast.toast(msg, {
        title: "Error",
        autoHideDelay: 10000,
        variant: "danger",
        solid: true
      });
    },
    showinputvalue: function(event) {
      this.name = event.target.value;
    },
    detailsRegistration(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.gender) {
        this.inValid.push("Gender type is required.");
      }
      if (!this.mobilenumber) {
        this.inValid.push("Mobile Number utype is required.");
      }
      if (!this.email) {
        this.inValid.push("Email type is required.");
      }
      if (!this.country) {
        this.inValid.push("Country type is required.");
      }
      if (!this.province) {
        this.inValid.push("Province type is required.");
      }
      if (!this.district) {
        this.inValid.push("District type is required.");
      }
      if (!this.address) {
        this.inValid.push("Address type is required.");
      }
      if (!this.designation) {
        this.inValid.push("Designation type is required.");
      }
      if (!this.certificate) {
        this.inValid.push("Certificate type is required.");
      }
      if (!this.passing_year) {
        this.inValid.push("Passing Year type is required.");
      }
      if (!this.institute) {
        this.inValid.push("Institute type is required.");
      }
      var phone_no1 = this.mobilenumber;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 14) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      var cnic_var = this.cnic;
      if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
        cnic_var = cnic_var.replace(/_/g, "");
        if (cnic_var.length < 17) {
          this.inValid.push("Must be valid CNIC, 16101-1114812-3");
        }
      } else if (
        this.passport == undefined ||
        this.passport == null ||
        this.passport == ""
      ) {
        this.inValid.push("Please Enter Passport Number");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        let self = this;
        this.openLoading();
        axios
          .post(localStorage.getItem("BASE_PATH") + "/register/trainee", {

            name: this.name,
            code: this.code,
            department_name: this.department,
            role: this.role,
            gender: this.gender,
            contactNo: this.mobilenumber,
            email: this.email,
            sessionBy: this.trainingId,
            statusApproval: 2,
            //insert trainee information
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            cnic: this.cnic,
            passport: this.passport,
            country: this.country,
            province: this.province,
            district: this.district,
            address: this.address,
            certificate: this.certificate,
            passing_year: this.passing_year,
            designation: this.designation,
            institute: this.institute,
            type: "Details Registration"
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been saved successfully!");
              self.resetForm();
              self.allTrainer();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    //Quick training
    quickRegistration(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.mobilenumber) {
        this.inValid.push("Mobile Number is required.");
      }
      if (!this.email) {
        this.inValid.push("Email type is required.");
      }
      if (!this.gender) {
        this.inValid.push("Gender is required.");
      }
      var phone_no1 = this.mobilenumber;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 14) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      var cnic_var = this.cnic;
      if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
        cnic_var = cnic_var.replace(/_/g, "");
        if (cnic_var.length < 17) {
          this.inValid.push("Must be valid CNIC, 16101-1114812-3");
        }
      } else if (
        this.passport == undefined ||
        this.passport == null ||
        this.passport == ""
      ) {
        this.inValid.push("Please Enter Passport Number");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(localStorage.getItem("BASE_PATH") + "/register/trainee", {
            //insert User informatiion in user table
            name: this.name,
            code: this.code,
            role: this.role,
            contactNo: this.mobilenumber,
            email: this.email,
            gender: this.gender,
            sessionBy: this.trainingId,
            //insert trainee quick information in trainee table
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            cnic: this.cnic,
            statusApproval: 2,
            passport: this.passport,
            type: "Quick Registration"
          })
          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been added successfully!");
              self.resetForm();
              self.allTrainer();
            } else if (response.data.error) {
              throw response.data.error;
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    submitEditForm(e) {
      e.preventDefault();
      this.inValid = [];
      if (!this.name) {
        this.inValid.push("Name is required.");
      }
      if (!this.mobilenumber) {
        this.inValid.push("Mobile Number is required.");
      }
      if (!this.email) {
        this.inValid.push("Email type is required.");
      }
      var phone_no1 = this.mobilenumber;
      if (phone_no1 == null || phone_no1 == undefined) {
        this.inValid.push("Must be valid Number, 0345-9992229");
      } else {
        phone_no1 = phone_no1.replace(/_/g, "");
        if (phone_no1.length < 14) {
          this.inValid.push("Must be valid Number, 0345-9992229");
        }
      }
      var cnic_var = this.cnic;
      if (cnic_var != null && cnic_var != undefined && cnic_var != "") {
        cnic_var = cnic_var.replace(/_/g, "");
        if (cnic_var.length < 17) {
          this.inValid.push("Must be valid CNIC, 16101-1114812-3");
        }
      } else if (
        this.passport == undefined ||
        this.passport == null ||
        this.passport == ""
      ) {
        this.inValid.push("Please Enter Passport Number");
      }
      for (var i = 0; i < this.inValid.length; i++) {
        this.$toasted.global.errorMsg(this.inValid[i]);
      }
      if (!this.inValid.length) {
        // define -this- outside axios methods because -this- inside axios refers to the axios object, not the vue component:
        let self = this;
        this.openLoading();
        axios
          .post(localStorage.getItem("BASE_PATH") + "/trainee/update", {
            //insert User informatiion in user table

            name: this.name,
            code: this.code,
            role: this.role,
            contactNo: this.mobilenumber,
            email: this.email,
            //insert trainee quick information in trainee table
            user_id: JSON.parse(localStorage.getItem("currentUser")).id,
            cnic: this.cnic,
            gender: this.gender,
            passport: this.passport,
            type: "Quick Registration",
            id: this.userId,
            primaryUserId: this.primaryUserId
          })

          .then(response => {
            this.closeLoading();
            if (response.data.success) {
              self.toastSuccess("Record has been updated successfully!");
              self.resetForm();
              self.allTrainer();
              this.isForm = true;
              this.isEditForm = false;
            } else if (response.data.error) {
              self.toastError(response.data.error);
            }
          })
          .catch(error => {
            self.toastError(error);
          });
      }
    },
    resetForm() {
      this.name = "";
      this.cnic = "";
      this.code = "";
      this.passport = "";
      this.gender = "";
      this.mobilenumber = "";
      this.email = "";
      this.country = "";
      this.province = "";
      this.district = "";
      this.address = "";
      this.department_name = "";
      this.designation = "";
      this.certificate = "";
      this.passing_year = "";
      this.institute = "";
    },
    successUpload() {
      this.$vs.notify({
        color: "primary",
        title: "Upload Success",
        text: "Your file is uploaded Successfully."
      });
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
      dateCheck() {
            const today = new Date();
            const dateString = this.trainingEndDate;
            const [day, month, year] = dateString.split("-");

            // Create a new date object for the target date
            const targetDate = new Date(`${year}-${month}-${day}`);

            // Add 3 days to the target date
            targetDate.setDate(targetDate.getDate() + 2);

            today.setHours(0, 0, 0, 0);
            targetDate.setHours(0, 0, 0, 0);

            // Compare today's date with the updated target date
            if (today > targetDate) {
                this.isDateValid = false;
            }

        },
  }
};
</script>

<style scoped>
.vs-breadcrumb {
  font-size: 18px !important;
  font-weight: 600 !important;
}
#progressbar .completed {
  color: #06a6e0;
}

#progressbar li.completed:before,
#progressbar li.completed:after {
  background: #06a6e0;
}

#grad1 {
  background-color: #fff;
}

#msform {
  text-align: center;
  position: relative;
  margin-top: 20px;
}

#msform fieldset .form-card {
  background: white;
  border: 0 none;
  border-radius: 0px;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  padding: 20px 40px 30px 40px;
  box-sizing: border-box;
  width: 94%;
  margin: 0 3% 20px 3%;
  position: relative;
}

#msform fieldset {
  padding: 10px;
  background: #f7f7f7;
  border: 0 none;
  border-radius: 2rem;
  box-sizing: border-box;
  width: 100%;
  margin: 0;
  border: 2px solid #ccc;
  padding-bottom: 20px;
  position: relative;
}

#msform fieldset:not(:first-of-type) {
  display: none;
}

#msform fieldset .form-card {
  text-align: left;
  color: #9e9e9e;
}

#msform .action-button {
  width: 100px;
  background: skyblue;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button:hover,
#msform .action-button:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px skyblue;
}

#msform .action-button-previous {
  width: 100px;
  background: #616161;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 0px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}

#msform .action-button-previous:hover,
#msform .action-button-previous:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px #616161;
}

select.list-dt {
  border: none;
  outline: 0;
  border-bottom: 1px solid #ccc;
  padding: 2px 5px 3px 5px;
  margin: 2px;
}

select.list-dt:focus {
  border-bottom: 2px solid skyblue;
}

.card {
  z-index: 0;
  border: none;
  border-radius: 0.5rem;
  position: relative;
}

.fs-title {
  font-size: 25px;
  color: #2c3e50;
  margin-bottom: 10px;
  font-weight: bold;
  text-align: left;
}

#progressbar {
  margin-bottom: 30px;
  overflow: hidden;
  color: lightgrey;
}

#progressbar .active {
  color: #000000;
}

#progressbar li {
  list-style-type: none;
  font-size: 12px;
  width: 9.5%;
  text-align: center;
  float: left;
  position: relative;
}

#progressbar #NewTraining:before {
  content: "1";
}

#progressbar #PoAssignment:before {
  content: "2";
}

#progressbar #TrainingInformation:before {
  content: "3";
}

#progressbar #TrainingAgenda:before {
  content: "4b";
}
#progressbar #Trainingmaterial:before {
  content: "4c";
}

#progressbar #TrainingAssessments:before {
  content: "4d";
}
#progressbar #TrainerRegistration:before {
  content: "4e";
}

#progressbar #TraineeRegistration:before {
  content: "4d";
}

#progressbar #AssessmentReview:before {
  content: "5";
}

#progressbar #Completion:before {
  content: "6";
}

#progressbar li:before {
  width: 35px;
  height: 35px;
  line-height: 30px;
  display: block;
  font-size: 18px;
  color: #ffffff;
  background: lightgray;
  border-radius: 50%;
  margin: 0 auto 10px auto;
  padding: 2px;
}

#progressbar li:after {
  content: "";
  width: 100%;
  height: 2px;
  background: lightgray;
  position: absolute;
  left: 0;
  top: 17px;
  z-index: -1;
}

#progressbar li.active:before,
#progressbar li.active:after {
  background: #000000;
}

.radio-group {
  position: relative;
  margin-bottom: 25px;
}

.radio {
  display: inline-block;
  width: 204;
  height: 104;
  border-radius: 0;
  background: lightblue;
  box-shadow: 0 2px 2px 2px rgba(0, 0, 0, 0.2);
  box-sizing: border-box;
  cursor: pointer;
  margin: 8px 2px;
}

.radio:hover {
  box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.3);
}

.radio.selected {
  box-shadow: 1px 1px 2px 2px rgba(0, 0, 0, 0.1);
}

.fit-image {
  width: 100%;
  object-fit: cover;
}
</style>
